export const NOTIFY_SUCCESS = 'success';
export const NOTIFY_WARNING = 'warning';
export const NOTIFY_INFO = 'info';
export const NOTIFY_ERROR = 'error';

export class EstadoSolicitudComercio {

    public static readonly LIST = [
        'PENDIENTE',
        'CANCELADO',
        'ACEPTADO'
    ];
}

export class EstadoPedido {

    public static readonly LIST = [
        'ACEPTADO',
        'PREPARACION',
        'PREPARADO',
        'REPARTO'
    ];
}
